@if (!errorsInQueue()) {
  <div>
    <rask-header size="2">Inga Fel i köerna</rask-header>
  </div>
}
@if (errorsInQueue()) {
  <rask-container-block>
    <rask-header size="2">Fel i köer</rask-header>
    <div class="list-container">
      @if (tableColumnsError) {
        <rask-table [data]="schemalaggningarErrors" [columns]="tableColumnsError"> </rask-table>
      }
    </div>
  </rask-container-block>
}

<rask-container-block>
  <rask-header size="2">Schemaläggningar</rask-header>
  <div class="list-container">
    @if (tableColumns) {
      <rask-table [data]="schemalaggningar" [columns]="tableColumns"> </rask-table>
    }
  </div>
</rask-container-block>
